// Packages
import { Platform } from 'react-native';

export const platform = () => ({ [Platform.OS]: true });
